module.exports = __webpack_public_path__ + "img/mysql.940ebfc2.png";